{
  "expo": {
    "name": "InA Coach",
    "slug": "InACoach",
    "owner": "bosconnect",
    "scheme": "inacoach",
    "version": "3.6.9",
    "orientation": "portrait",
    "icon": "./assets/icons/icon_blue_512x512.png",
    "userInterfaceStyle": "automatic",
    "splash": {
      "image": "./assets/icons/splash_512x512.png",
      "resizeMode": "contain",
      "backgroundColor": "#ffffff"
    },
    "newArchEnabled": false,
    "updates": {
      "fallbackToCacheTimeout": 500,
      "url": "https://u.expo.dev/cfa15771-fd46-4f70-b566-a3d9140650aa"
    },
    "runtimeVersion": {
      "policy": "sdkVersion"
    },
    "assetBundlePatterns": [
      "**/*"
    ],
    "ios": {
      "bundleIdentifier": "de.bosconnect.inacoach",
      "supportsTablet": true,
      "requireFullScreen": true,
      "infoPlist": {
        "ITSAppUsesNonExemptEncryption": false
      },
      "googleServicesFile": "./google-services/GoogleService-Info.plist"
    },
    "android": {
      "package": "de.bosconnect.inacoach",
      "adaptiveIcon": {
        "foregroundImage": "./assets/icons/splash_512x512.png",
        "backgroundColor": "#93C700"
      },
      "softwareKeyboardLayoutMode": "pan",
      "googleServicesFile": "./google-services/google-services.json"
    },
    "androidStatusBar": {
      "translucent": true
    },
    "web": {
      "favicon": "./assets/icons/icon_blue_48x48.png",
      "bundler": "metro"
    },
    "notification": {
      "icon": "./assets/icons/icon_android_mono_96x96.png"
    },
    "plugins": [
      "@react-native-firebase/app",
      "@react-native-firebase/messaging",
      "expo-notifications",
      [
        "expo-build-properties",
        {
          "ios": {
            "useFrameworks": "static"
          }
        }
      ],
      [
        "expo-image-picker",
        {
          "photosPermission": "Photo libary access is used to add existing photos and videos to your worflows and user profile.",
          "cameraPermission": "Camera access is used to capture photos and videos within the app in order to add these to your worflows and user profile.",
          "microphonePermission": "Microphone access is used to caputure audio in video recordings for your workflows."
        }
      ],
      [
        "expo-media-library",
        {
          "photosPermission": "Photo libary access is used to add existing photos and videos to your worflows and user profile.",
          "savePhotosPermission": "Photo libary access is used to save photos and videos from your worflows and user profile.",
          "isAccessMediaLocationEnabled": true
        }
      ],
      [
        "@sentry/react-native/expo",
        {
          "organization": "bosconnect",
          "project": "app",
          "url": "https://sentry.ina.coach"
        }
      ],
      [
        "expo-font"
      ],
      [
        "expo-localization"
      ]
    ],
    "description": ""
  }
}
